import template from './dashboard-root-view.component.html';
import { DashboardRootViewController as controller } from './controllers/dashboard-root-view.controller';
import './style.less';

export const dashboardRootViewComponent = {
	template,
	controller
};
